import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface NzWelcomeModalProps {
  open: boolean;
  onConfirm: () => void;
}

/**
 * Modal de bienvenida mostrado ANTES de forzar la guía de onboarding de Agenda a
 * psicólogas NZ en estado "new" sin horarios reales cargados. No se puede cerrar sin
 * usar el CTA — a propósito, así siempre lleva a la guía forzada.
 */
const NzWelcomeModal: React.FC<NzWelcomeModalProps> = ({ open, onConfirm }) => {
  return (
    <Dialog open={open} onOpenChange={() => { /* no dismissable: solo se cierra con el CTA */ }}>
      <DialogContent
        data-testid="nz-welcome-modal"
        className="sm:max-w-[28rem] p-0 overflow-hidden"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="text-[1.125rem] font-semibold text-[#4a3d73]">
            ¡Bienvenida a Psi Platform!
          </DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-5 text-[0.875rem] text-gray-600 leading-relaxed">
          Esta es tu herramienta de trabajo. Ya la conociste brevemente, pero queremos
          ayudarte a cargar tu disponibilidad la primera vez, así que ¡repasemos!
        </div>
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end">
          <button
            type="button"
            data-testid="nz-welcome-modal-confirm"
            onClick={onConfirm}
            className="px-5 py-2 rounded-full text-sm font-semibold text-white border-none cursor-pointer transition-all hover:brightness-90"
            style={{ background: '#6D57BC' }}
          >
            ¡Vamos!
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NzWelcomeModal;
